import { render } from "./Alignment.vue?vue&type=template&id=1856a188&scoped=true&ts=true"
import script from "./Alignment.vue?vue&type=script&lang=ts"
export * from "./Alignment.vue?vue&type=script&lang=ts"

import "./Alignment.vue?vue&type=style&index=0&id=1856a188&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1856a188"]])

export default __exports__